// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"213":"dd030c26d7f86776","888":"79681eb5f8a36ae4"}[chunkId] + ".css";
};